import { render, staticRenderFns } from "./DispatcherMappings.vue?vue&type=template&id=370d4620&"
import script from "./DispatcherMappings.vue?vue&type=script&lang=js&"
export * from "./DispatcherMappings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports